import React from 'react';
import './styles.scss';
import Icon, {
  PoweredByBalance,
  VisaIcon,
  MasterCardWithText,
  AmericanExpress,
  SSLIcon,
} from 'components/Atoms/Icon';
import cn from 'classnames';

const PaymentLogos = ({ className, hideVisaCard = false }) => {
  return (
    <div
      className={cn(
        className,
        'flex-center',
        'align-items-center',
        'payment-logos'
      )}
    >
      <div className="d-inline-block mr-10">
        <Icon className="balance-icon" component={PoweredByBalance} />
      </div>
      {hideVisaCard ? null : (
        <>
          <div className="d-inline-block mr-10">
            <Icon className="icon" component={VisaIcon} />
          </div>
          <div className="d-inline-block mr-10">
            <Icon className="icon" component={MasterCardWithText} />
          </div>
          <div className="d-inline-block mr-10">
            <Icon
              className="american-express-icon"
              component={AmericanExpress}
            />
          </div>
        </>
      )}

      <div className="d-inline-block">
        <Icon className="icon" component={SSLIcon} />
      </div>
    </div>
  );
};

PaymentLogos.defaultProps = {
  className: 'mt-25',
};

export default PaymentLogos;
